// extracted by mini-css-extract-plugin
export default {"timer":"eIFNu6HoBiHWjYMbn9kv","separator":"eZuszNeUBjp_goeMh_TH"};